<nz-input-group [nzAddOnAfter]="createMode && upsertComponent && (isSearchPerformed || value) ? suffixActions : undefined" class="p-0">
    <nz-select
        #valueSelect
        [disabled]="isDisabled"
        [ngModel]="value"
        (ngModelChange)="handleChange($event)"
        (nzBlur)="onTouched()"
        nzShowSearch
        nzServerSearch
        [nzAllowClear]="allowClear"
        [nzPlaceHolder]="fieldPlaceholder"
        [nzShowArrow]="false"
        [nzFilterOption]="nzFilterOption"
        (nzOnSearch)="search($event)"
    >
        @for (o of listOfOption; track o.value.id) {
            <nz-option [nzLabel]="o.text" [nzValue]="objectMode ? o.value : o.value.id"> </nz-option>
        }
    </nz-select>
    <ng-template #suffixActions>
        @if (!isDisabled) {
            <nz-flex nzGap="small">
                @if (isSearchPerformed && createMode) {
                    <button nz-button [nzSize]="'small'" [nzType]="'primary'" (click)="addObject()">
                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                    </button>
                }

                @if (value && editAllowed) {
                    <button *hasPermission="editPermissions" nz-button [nzType]="'primary'" [nzSize]="'small'" (click)="editObject()">
                        <i nz-icon nzType="edit" nzTheme="outline"></i>
                    </button>
                }

                @if (value && allowClear) {
                    <button nz-button nzDanger [nzType]="'primary'" [nzSize]="'small'" (click)="clearSelection()">
                        <i nz-icon nzType="minus" nzTheme="outline"></i>
                    </button>
                }
            </nz-flex>
        }
    </ng-template>
</nz-input-group>
